import SequencePlayer from "@/employee/SequencePlayer"
import util from "@/util"
import { custom, serializable } from "serializr"

export default class CollectionPlayer {
  public readonly id: string
  public readonly info: any

  private currentTrackIndex = 0
  private sequences: SequencePlayer[] = []
  private extra: SequencePlayer[] = []

  constructor(id: string = "", info: any = undefined) {
    this.id = id

    if (info == undefined) {
      return
    }

    this.info = info
    if (!('sequences' in info)) {
      console.error(`No "sequences" tag for collection "${id}". Info was:`, info)
      return
    }

    this.load()
  }

  load() {
    let i = 0
    for (let sequence of this.info.sequences) {
      let title = (sequence.title) ? sequence.title : this.info.title
      let length = (sequence.length) ? sequence.length : 1

      // If a sequence has its own description, prepend it to the collection description.
      let description = (this.info.description) ? this.info.description : ""
      if (sequence.description) {
        description = `<p>${sequence.description}</p> <p>${this.info.description}</p>`
      }

      // All but first sequence sequences default to their firstImage if they have to thumb
      let thumb = (sequence.thumb) ? sequence.thumb : sequence.firstImage

      if (i == 0) {
        // First sequence defaults to collection's thumb, before its first image.
        thumb = (sequence.thumb) ? sequence.thumb : (this.info.thumb) ? this.info.thumb : sequence.firstImage
      }
      this.sequences.push(new SequencePlayer(this.id, {
        title: title,
        description: description,
        length: length,
        firstImage: sequence.firstImage,
        thumb: thumb
      })
      )
      i += 1
    }
  }

  allSequences(): SequencePlayer[] {
    let list: SequencePlayer[] = []
    list = list.concat(this.sequences)
    list = list.concat(this.extra)
    return list
  }

  /**
   *
   * @param index index of the sequence to use, or the title of the sequence
   */
  gotoTrack(index: number | string): CollectionPlayer {
    if (typeof index == "number") {
      this.currentTrackIndex = index
    } else {
      for (let [i, sequence] of this.sequences.entries()) {
        if (sequence.title == index) this.currentTrackIndex = i
      }
    }
    return this
  }

  goto(i: number): CollectionPlayer {
    this.activeSequence().goto(i)
    return this
  }

  next(): CollectionPlayer {
    this.activeSequence().next()
    return this
  }

  prev(): CollectionPlayer {
    this.activeSequence().prev()
    return this
  }

  get(): string {
    return this.activeSequence().get()
  }

  getThumb(): string {
    return this.activeSequence().getThumb()
  }

  getTitle(): string {
    return this.info.title
  }

  getDescription(): string {
    return this.activeSequence().info.description
  }

  getCurrentIndex(): number {
    return this.activeSequence().getCurrentIndex()
  }

  activeLength(): number {
    return this.activeSequence().getLength()
  }

  primaryLength(): number {
    return this.sequences[0].getLength()
  }

  secondaryLength(): number {
    return this.totalLength() - this.primaryLength()
  }

  totalLength(): number {
    let sum = 0
    for (let sequence of this.sequences) {
      sum += sequence.getLength()
    }
    return sum
  }

  activeSequence(): SequencePlayer {
    return this.sequences[this.currentTrackIndex]
  }
}
